<template>
  <div class="max-w-[800px] w-full">
    <BillingOverview />
    <BillingPaymentMethod
      :invoice-details="billingInfo?.invoiceDetails"
      :payment-method-details="billingInfo?.paymentMethod"
      :balance="billingInfo?.balance"
    />
    <BillingInvoiceDetails
      v-if="isStripeCustomer"
      :details="billingInfo?.invoiceDetails"
      :is-loading="isLoading"
    />
    <BillingHistory />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import requests from '@/vuex/requests.js';
import { useQuery } from '@tanstack/vue-query';
import { useStore } from 'vuex';
import BillingOverview from './components/billing/BillingOverview.vue';
import BillingPaymentMethod from './components/billing/BillingPaymentMethod.vue';
import BillingInvoiceDetails from './components/billing/BillingInvoiceDetails.vue';
import BillingHistory from './components/billing/BillingHistory.vue';

const store = useStore();

const { isLoading, data: billingInfo } = useQuery({
  queryKey: ['workspaceSubscriptionBillingInfo'],
  queryFn: () =>
    requests.workspaces.subscription.billingInfo(
      store.getters['workspace/getId']
    ),
});

const isStripeCustomer = computed(
  () => store.getters['workspace/getIsStripeCustomer']
);
</script>
